<template>
  <v-dialog v-model="dialog" max-width="900px" persistent>
    <BaseBodyDialog title="CHI TIẾT KỲ ĐÓNG" :loading="loading" @close="close" @save="saveChanges">
      <v-container class="pa-0 mt-6">
        <v-row>
          <v-col cols="12">
            <v-card elevation="0" outlined>
              <v-data-table
                :headers="headers"
                :items="items"
                hide-default-footer
                class="elevation-0"
                disable-sort
                dense
              >
                <template #[`item.month`]="{ item }">
                  {{ item.metadata.month }}
                </template>
                <template #[`item.amount`]="{ item }">
                  <div class="font-weight-medium">
                    {{ Number(item.metadata.amount).toLocaleString() }} VNĐ
                    <span class="grey--text text--darken-1">{{ formatPriceType(item.metadata.priceType) }}</span>
                  </div>
                </template>
                <template #[`item.paymentType`]="{ item }">
                  <v-chip small :color="item.metadata.paymentType === 'pre' ? 'success' : 'primary'" text-color="white">
                    {{ formatPaymentType(item.metadata.paymentType) }}
                  </v-chip>
                </template>
                <template #[`item.totalLessons`]="{ item }">
                  <div class="text-center">{{ item.metadata.totalLessons }}</div>
                </template>
                <template #[`item.price`]="{ item }">
                  <div class="font-weight-bold primary--text">{{ Number(item.price).toLocaleString() }} VNĐ</div>
                </template>
                <template #[`item.actualPrice`]="{ item }">
                  <v-text-field
                    :disabled="item.period.status === 'finished'"
                    class="py-4 px-2"
                    v-model="item.actualPrice"
                    type="number"
                    dense
                    hide-details
                    outlined
                    @change="() => handleChangePrice(item)"
                  ></v-text-field>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </BaseBodyDialog>
  </v-dialog>
</template>

<script>
import moment from 'moment'
import { mapState, mapActions } from 'vuex'
import get from 'lodash-es/get'
import BaseBodyDialog from '@/components/basic/dialog/BaseBodyDialog.vue'

export default {
  name: 'DialogDetailPeriod',

  components: {
    BaseBodyDialog,
  },

  data() {
    return {
      dialog: false,
      loading: false,
      headers: [
        { text: 'Tháng', value: 'month', align: 'left' },
        { text: 'Số buổi', value: 'totalLessons', align: 'center' },
        { text: 'Hình thức thu', value: 'paymentType', align: 'center' },
        { text: 'Số tiền', value: 'amount', align: 'right' },
        { text: 'Số tiền dự kiến', value: 'price', align: 'right' },
        { text: 'Số tiền thực tế', value: 'actualPrice', align: 'center', width: '20%' },
      ],
      modifiedPrices: {},
    }
  },

  computed: {
    ...mapState('tuitionFeeGroupHeadFee', ['groupHeadFee']),
    items() {
      return get(this.groupHeadFee, 'prices', [])
    },
  },

  methods: {
    ...mapActions('tuitonFeePrice', ['updateActualPrice']),
    ...mapActions('tuitionFeeGroupHeadFee', ['fetchOne', 'updatePrice']),
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY')
    },
    formatPriceType(type) {
      const types = {
        per_session: '/ buổi',
        monthly: '/ tháng',
        quarterly: '/ 3 tháng',
        course: '/ khóa',
      }
      return types[type] || type
    },
    formatPaymentType(type) {
      const types = {
        pre: 'Thu trước',
        post_actual: 'Thu sau (theo thực tế)',
        post_expected: 'Thu sau (theo dự kiến)',
      }
      return types[type] || type
    },
    openDialog(item) {
      this.dialog = true
      const cloneItem = { ...item }
      const cloneMeta = { ...cloneItem.metadata }
      this.fetchOne(cloneMeta['apply'])
    },
    close() {
      this.dialog = false
      this.modifiedPrices = {}
    },
    handleChangePrice(item) {
      this.modifiedPrices[item.id] = item.actualPrice
    },
    async saveChanges() {
      this.loading = true
      try {
        const promises = Object.entries(this.modifiedPrices).map(([id, actualPrice]) => {
          return this.updateActualPrice({ id, actualPrice })
        })
        await Promise.all(promises)
        this.$alert.success('Cập nhật giá thành công')
        this.close()
      } catch (error) {
        this.$alert.error('Có lỗi xảy ra khi cập nhật giá')
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
